import styled from 'styled-components';
import { customBreakPoint, mobileBreakPoint } from '~/styles/break-points';

export const ImageComparisorStyle = styled.div<{ $aspectRatio?: string }>`
	width: 100%;
	height: 100%;
	aspect-ratio: ${(props) => (props.$aspectRatio ? `${props.$aspectRatio} !important` : '4 / 3')};
	position: relative;
	overflow: hidden;

	${customBreakPoint(
		mobileBreakPoint,
		`
			aspect-ratio: 15 / 9;
		`,
	)}

	.comparison-information {
		background: ${(props) => props.theme.sys.gradient.elevation.level1.fill};
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		> p {
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0 1rem;
			width: 25%;
			text-align: center;
			margin-left: 50%;
		}
	}
`;
